import { Check, X, Minus } from "lucide-react";

export const AiCodingComparison = () => {
  const tools = [
    {
      name: "GitHub Copilot",
      pricing: "$10-19/mo",
      completion: true,
      chat: true,
      multiFile: false,
      codebase: false,
      reasoning: "medium",
      bestFor: "Inline completions, enterprise teams",
    },
    {
      name: "Cursor",
      pricing: "$20/mo",
      completion: true,
      chat: true,
      multiFile: true,
      codebase: true,
      reasoning: "high",
      bestFor: "Full IDE experience, complex projects",
    },
    {
      name: "Claude (Anthropic)",
      pricing: "$20/mo",
      completion: false,
      chat: true,
      multiFile: true,
      codebase: false,
      reasoning: "highest",
      bestFor: "Architecture, debugging, learning",
    },
    {
      name: "ChatGPT",
      pricing: "$20/mo",
      completion: false,
      chat: true,
      multiFile: true,
      codebase: false,
      reasoning: "high",
      bestFor: "General coding questions, versatility",
    },
    {
      name: "Codeium",
      pricing: "Free/$15/mo",
      completion: true,
      chat: true,
      multiFile: false,
      codebase: false,
      reasoning: "medium",
      bestFor: "Budget-conscious, free tier users",
    },
    {
      name: "Amazon Q",
      pricing: "$19/mo",
      completion: true,
      chat: true,
      multiFile: true,
      codebase: true,
      reasoning: "medium",
      bestFor: "AWS integration, enterprise",
    },
  ];

  const renderIcon = (value: boolean | string) => {
    if (typeof value === "boolean") {
      return value ? (
        <Check className="w-5 h-5 text-chart-4" />
      ) : (
        <X className="w-5 h-5 text-muted-foreground/50" />
      );
    }
    return null;
  };

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Feature Comparison
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Here's how the major AI coding assistants stack up against each other in 2026.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 font-medium text-foreground">Tool</th>
              <th className="text-left py-3 px-4 font-medium text-foreground">Price</th>
              <th className="text-center py-3 px-4 font-medium text-foreground">Completion</th>
              <th className="text-center py-3 px-4 font-medium text-foreground">Chat</th>
              <th className="text-center py-3 px-4 font-medium text-foreground">Multi-file</th>
              <th className="text-center py-3 px-4 font-medium text-foreground">Codebase</th>
              <th className="text-left py-3 px-4 font-medium text-foreground">Best For</th>
            </tr>
          </thead>
          <tbody>
            {tools.map((tool, index) => (
              <tr key={index} className="border-b border-border/50 hover:bg-muted/30">
                <td className="py-3 px-4 font-medium text-foreground">{tool.name}</td>
                <td className="py-3 px-4 text-muted-foreground">{tool.pricing}</td>
                <td className="py-3 px-4 text-center">{renderIcon(tool.completion)}</td>
                <td className="py-3 px-4 text-center">{renderIcon(tool.chat)}</td>
                <td className="py-3 px-4 text-center">{renderIcon(tool.multiFile)}</td>
                <td className="py-3 px-4 text-center">{renderIcon(tool.codebase)}</td>
                <td className="py-3 px-4 text-muted-foreground">{tool.bestFor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
